import MicroModal from "micromodal";

document.body.addEventListener('htmx:afterRequest', (event) => {
    const modalCart = document.querySelector('#modal-cart');
    const forms = document.querySelectorAll("form");
    if (modalCart.contains(event.target)) return;
    const xhr = event.detail.xhr;
    const status = xhr.status;
    const response = xhr.responseText;

    let valideModal = false;
    let idModal;
    const modals = document.querySelectorAll(".modal");

    modals.forEach((modal) => {
        if (modal.classList.contains("is-open")) {
            valideModal = true;
            idModal = modal.id;
        }
    })
    if (valideModal) {
        MicroModal.close(idModal);
    }

    forms.forEach((form) => {
        const fields = form.querySelectorAll (".field");
        form.reset();

        fields.forEach((field) => {
            field.classList.remove("active");
        })
    })

    if (status >= 200 && status < 300) {
        setTimeout(async () => {
            MicroModal.show('modal-success');
        }, 300);
    } else {
        console.warn('Ошибка при отправке:', response);

        MicroModal.show('modal-fail');
    }
});